
import PropTypes from 'prop-types';
import { Decimal } from 'decimal.js';
import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';


export class InputWidget extends Component {

  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    toUpperCase: PropTypes.bool,
    toLowerCase: PropTypes.bool,
    emptyValue: PropTypes.any
  };

  static defaultProps = {
    emptyValue: ''
  }

  handleChange = (e) => {
    const { onChange, toUpperCase, toLowerCase, emptyValue } = this.props;
    let value = e.target.value;
    if (toUpperCase) {
      value = value.toUpperCase();
    }
    else if (toLowerCase) {
      value = value.toLowerCase();
    }
    onChange(value.length === 0 ? emptyValue : value);
  };

  render() {
    let { value, ...otherProps } = this.props;
    if (typeof  value === 'number') {
      value = value.toString();
    }
    else if (typeof value !== 'string') {
      value = '';
    }

    return (
      <TextField
        type="text"
        variant="outlined"
        {...otherProps}
        value={value}
        onChange={(e) => this.handleChange(e)}
      />
    )
  }
}


export class InputNumberWidget extends Component {

  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired
  };

  handleChange = (e) => {
    const { onChange } = this.props;
    let value = e.target.value;

    if (value === '') {
      onChange(null);
    }
    else {
      onChange(value);
    }
  };

  render() {
    let { value, ...otherProps } = this.props;
    if (value === null || value === undefined) {
      value = '';
    }

    return (
      <TextField
        type="number"
        variant="outlined"
        {...otherProps}
        value={value}
        onChange={(e) => this.handleChange(e)}
      />
    )
  }
}


export class InputSmartNumberWidget extends Component {

  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired
  };

  handleChange = (e) => {
    const { onChange } = this.props;
    let value = e.target.value;

    if (value === '') {
      onChange(null);
    }
    else {
      value = value.replace('-', '');
      let x = new Decimal(value);
      if (x.decimalPlaces() > 2) {
        value = x.toFixed(2);
      }
      onChange(value);
    }
  };

  displayValue = (value) => {
    let x = new Decimal(value);
    if (x.isInteger()) {
      return x;
    }
    else if (x.decimalPlaces() === 0) {
      return parseInt(x.toFixed(2));
    }
    else {
      return x.toFixed(2);
    }
  };

  handleBlur = (e) => {
    const { onChange } = this.props;
    let value = e.target.value;
    if (value === '') {
      onChange(null);
    }
    else {
      value = this.displayValue(value);
      onChange(value);
    }
  };

  componentDidMount() {
    const { onChange, value } = this.props;
    if (value) {
      onChange(this.displayValue(value));
    }
  }

  render() {
    let { value, ...otherProps } = this.props;
    if (value === null || value === undefined) {
      value = '';
    }

    return (
      <TextField
        type="number"
        variant="outlined"
        {...otherProps}
        value={value}
        onChange={(e) => this.handleChange(e)}
        onBlur={(e) => this.handleBlur(e)}
      />
    )
  }
}